import { useAccount, useIsAuthenticated } from '@azure/msal-react';
import React from 'react';

export type AuthorizedProps = {
    role?: string | null;
    children: React.ReactNode | ((role?: string[] | null) => React.ReactNode);
};

const Authorized = ({ children, role }: AuthorizedProps) => {
    const isAuthenticated = useIsAuthenticated();
    const account = useAccount();
    const child =
        typeof children === 'function'
            ? children.call(this, account?.idTokenClaims?.roles)
            : children;

    if (!role) {
        return <React.Fragment>{isAuthenticated && child}</React.Fragment>;
    }

    return (
        <React.Fragment>
            {isAuthenticated && account?.idTokenClaims?.roles?.includes(role) && child}
        </React.Fragment>
    );
};

export default Authorized;
